import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("ux-async-html", () => {
    it("should render the component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-async-html src="/mock-data/async-html.html"></ux-async-html>`);
        const el = await page.find("ux-async-html");
        expect(el).toHaveClass("hydrated");
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-async-html src="/mock-data/async-html.html"></ux-async-html>`);
    });
});
